// src/pages/roles/RoleList.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import roleService from '../../services/roleService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import { includes, map } from 'lodash';

const RoleList = () => {
  const [roles, setRoles] = useState([]);
  const roleList = JSON.parse(localStorage?.getItem('roles'));
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRoles = async () => {
      const response = await roleService.getRoles();
      setRoles(
        map(response.data, (data) => {
          return {
            ...data,
            isEditable: includes(roleList, data?.name) ? false : true,
          };
        })
      );
    };
    fetchRoles();
  }, []);

  const handleDelete = async (id) => {
    await roleService.deleteRole(id);
    setRoles(roles.filter((role) => role.id !== id));
  };

  return (
    <LayoutContainer>
      <AdminHeader title='Roles' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          {/* <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/role/new')}
          >
            Add Role
          </Button> */}
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Roles</TableCell>
              {/* <TableCell>Description</TableCell> */}
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {roles.map((role, index) => (
              <TableRow
                key={role.id}
                sx={{
                  backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                  // '&:hover': { backgroundColor: '#e0f7fa' },
                }}
              >
                <TableCell
                  sx={{
                    padding: '12px !important',
                    paddingLeft: '1rem !important',
                    fontSize: '0.75rem !important',
                    borderBottom: '1px solid #ddd',
                  }}
                >
                  {role.name}
                </TableCell>
                {/* <TableCell>{role.description}</TableCell> */}
                <TableCell
                  sx={{
                    padding: '12px !important',
                    paddingLeft: '1rem !important',
                    fontSize: '0.75rem !important',
                    borderBottom: '1px solid #ddd',
                  }}
                >
                  {/* <IconButton
                    onClick={() => navigate(`/role/edit/${role.id}`)}
                    disabled={!role?.isEditable}
                    sx={{
                      cursor: role?.isEditable ? 'pointer' : 'not-allowed',
                      pointerEvents : 'auto'
                    }}
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton> */}
                  {/* <IconButton onClick={() => handleDelete(role.id)}>
                    <DeleteIcon sx={{ color: '#be210b' }} />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default RoleList;
